"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SfnDoShopSynchronizationOutputDto = void 0;
class SfnDoShopSynchronizationOutputDto {
}
exports.SfnDoShopSynchronizationOutputDto = SfnDoShopSynchronizationOutputDto;
//# sourceMappingURL=SfnDoShopSynchronizationOutputDto.js.map